import responsiveVars from '@/styles/responsive.module.scss';

const _desktop = Number.parseInt(responsiveVars?.desktop) || 1025;
const _tablet = Number.parseInt(responsiveVars?.tablet) || 482;

const state = {
  windowWidth: typeof window !== 'undefined' ? window.innerWidth : 0,
};

const getters = {
  windowWidth: (state) => state.windowWidth,
  is_desktop_reactive: (state) => {
    if (typeof window === 'undefined' || state.windowWidth <= 0) return false;
    return state.windowWidth >= _desktop;
  },
  is_tablet_reactive: (state) => {
    if (typeof window === 'undefined' || state.windowWidth <= 0) return false;
    return state.windowWidth >= _tablet && state.windowWidth < _desktop;
  },
  is_mobile_reactive: (state) => {
    if (typeof window === 'undefined' || state.windowWidth <= 0) return false;
    return state.windowWidth < _tablet;
  },
};

const mutations = {
  setGlobalStatus(state, data = {}) {
    Object.keys(data).forEach(key => {
      if (key in state) {
        state[key] = data[key];
      }
    })
  },
  setWindowWidth(state, width) {
    state.windowWidth = width;
  },
};

const actions = {};

export default {
  state,
  getters,
  mutations,
  actions,
};
